import { conNota, ESCALA, type Formulario, type Notas, valorDe } from "./tipos"

/**
 * Los criterios de un formulario, bloque a bloque, con su selector de nota (1 a 5 o N/O)
 * y, si se pide, el campo de hechos observados. Lo usan la Dirección y el trabajador: la
 * misma escala y los mismos criterios, que es lo que hace comparables las dos miradas.
 */
export function Calificacion({
  formulario,
  notas,
  onNotas,
  hechos,
  onHechos,
  soloLectura = false,
  prefijo,
}: {
  formulario: Formulario
  notas: Notas
  onNotas: (n: Notas) => void
  hechos?: Record<string, string>
  onHechos?: (h: Record<string, string>) => void
  soloLectura?: boolean
  prefijo: string
}) {
  return (
    <div className="space-y-4">
      {formulario.bloques.map((b) => (
        <fieldset key={b.clave} className="tarjeta space-y-3 p-4">
          <legend className="text-sm font-semibold">
            {b.clave} · {b.nombre}{" "}
            <span className="font-normal" style={{ color: "var(--fg-muted)" }}>
              · peso {Math.round(Number(b.peso) * 100)} %
            </span>
          </legend>
          {b.criterios.map((c) => {
            const id = `${prefijo}-${c.codigo}`
            return (
              <div key={c.codigo} className="grid gap-2 sm:grid-cols-[1fr_12rem]">
                <label htmlFor={id} className="text-sm">
                  <span className="font-medium">
                    {c.codigo}. {c.nombre}
                  </span>
                  <span className="block text-xs" style={{ color: "var(--fg-muted)" }}>
                    {c.descripcion}
                  </span>
                </label>
                <select
                  id={id}
                  className="campo"
                  disabled={soloLectura}
                  value={valorDe(notas, c.codigo)}
                  onChange={(e) => onNotas(conNota(notas, c.codigo, e.target.value))}
                >
                  {ESCALA.map((o) => (
                    <option key={o.valor} value={o.valor}>
                      {o.texto}
                    </option>
                  ))}
                </select>
                {hechos !== undefined && onHechos && (
                  <textarea
                    aria-label={`Hechos observados en ${c.nombre}`}
                    className="campo sm:col-span-2"
                    rows={1}
                    disabled={soloLectura}
                    placeholder="Hechos observados (casos concretos, no impresiones)"
                    value={hechos[c.codigo] ?? ""}
                    onChange={(e) => onHechos({ ...hechos, [c.codigo]: e.target.value })}
                  />
                )}
              </div>
            )
          })}
        </fieldset>
      ))}
    </div>
  )
}
